import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../common/LanguageSwitcher";

const Header = ({ sidebarCollapsed }) => {
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const location = useLocation();
  const { t } = useTranslation(['navigation']);

  // Get page title from current route
  const getPageTitle = () => {
    const path = location.pathname;
    const routes = {
      "/dashboard": t('navigation:pageTitles.dashboard'),
      "/clubs": t('navigation:pageTitles.clubs'),
      "/events": t('navigation:pageTitles.events'),
      "/users": t('navigation:pageTitles.users'),
      "/universities": t('navigation:pageTitles.universities'),
      "/campuses": t('navigation:pageTitles.campuses'),
      "/faculties": t('navigation:pageTitles.faculties'),
      "/departments": t('navigation:pageTitles.departments'),
      "/countries": t('navigation:pageTitles.countries'),
      "/cities": t('navigation:pageTitles.cities'),
      "/categories": t('navigation:pageTitles.categories'),
    };
    return routes[path] || t('navigation:pageTitles.adminPanel');
  };

  return (
    <header
      className={`header bg-white shadow-sm border-bottom position-fixed w-100 top-0 ${
        sidebarCollapsed ? "header-collapsed" : "header-expanded"
      }`}
    >
      <div className="container-fluid px-4" style={{ maxWidth: "100%" }}>
        <div className="d-flex align-items-center justify-content-between py-3 gap-2">
          {/* Left Section - Page Title & Breadcrumb */}
          <div className="header-left d-flex align-items-center flex-grow-1" style={{ minWidth: 0, overflow: "hidden" }}>
            <div className="text-truncate">
              <h4 className="mb-0 fw-bold text-dark text-truncate">{getPageTitle()}</h4>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb breadcrumb-modern mb-0">
                  <li className="breadcrumb-item">
                    <i className="fas fa-home me-1 text-muted"></i>
                    <span className="text-muted">{t('navigation:breadcrumbs.admin')}</span>
                  </li>
                  <li className="breadcrumb-item active text-primary fw-medium">
                    {getPageTitle()}
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          {/* Right Section - Language Switcher */}
          <div className="header-right d-flex align-items-center flex-shrink-0">
            <LanguageSwitcher />
          </div>
        </div>
      </div>

      {/* Overlay for mobile dropdowns */}
      {(showUserDropdown || showNotifications) && (
        <div
          className="dropdown-backdrop"
          onClick={() => {
            setShowUserDropdown(false);
            setShowNotifications(false);
          }}
        />
      )}
    </header>
  );
};

export default Header;
